<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="about-page">
    <!-- HERO -->
    <section class="page-hero">
      <div class="page-hero-inner">
        <div class="section-label">Our Story</div>
        <h1 class="page-title">關於綠憩植研</h1>
        <p class="page-sub">一份對生命的關懷，開啟綠憩植研的誕生</p>
      </div>
    </section>

    <!-- STORY -->
    <section class="story-section">
      <div class="story-inner">
        <div class="story-img">
          <img
            src="@/assets/about-hero.png"
            alt="綠憩植研 品牌故事"
            class="story-img-photo"
          />
          <div class="story-img-overlay">
            <p>植物不只是裝飾，<br />更是一種陪伴。</p>
            <span>— 綠憩植研 創辦理念</span>
          </div>
        </div>
        <div class="story-body">
          <div class="section-label">Our Story</div>
          <h2 class="section-title">從一份照護困擾，<br />到一個品牌的誕生</h2>
          <p class="story-text">
            綠憩植研源於對生命陪伴的體會，從植物照護需求出發，希望讓更多人輕鬆享受綠色療癒生活。
          </p>
          <p class="story-text">
            我們相信，在忙碌與壓力交織的現代生活裡，每一株植物都能帶來一份平靜與希望。用科技降低照護負擔，讓植物重新成為生活中的陪伴。
          </p>
          <p class="story-text">每一份綠意，都蘊藏著成長、希望與幸福。</p>
          <div class="story-values">
            <div v-for="v in storyValues" :key="v" class="story-value-tag">
              {{ v }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- PAIN POINTS -->
    <section class="pain-section">
      <div class="pain-inner">
        <div class="section-label" style="justify-content: center">
          We Solve
        </div>
        <h2 class="section-title" style="text-align: center">
          喜歡植物，不該成為一種負擔
        </h2>
        <p
          class="section-sub"
          style="text-align: center; max-width: 500px; margin: 12px auto 40px"
        >
          綠憩植研源於真實的照護困擾，以科技解決每一道植物養護的難題。
        </p>
        <div class="pain-grid">
          <div v-for="p in painPoints" :key="p.title" class="pain-item">
            <div class="pain-icon">{{ p.icon }}</div>
            <div class="pain-title" v-html="p.title"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- TECH -->
    <section class="tech-section">
      <div class="tech-inner">
        <div class="section-label" style="justify-content: center">
          Core Technology
        </div>
        <h2 class="section-title" style="text-align: center">
          核心科技，極簡養護
        </h2>
        <p
          class="section-sub"
          style="text-align: center; max-width: 500px; margin: 12px auto 40px"
        >
          三項專利技術，讓植物在最佳環境下生長
        </p>
        <div class="tech-grid">
          <div v-for="t in techCards" :key="t.name" class="tech-card">
            <div class="tech-icon">{{ t.icon }}</div>
            <div class="tech-name">{{ t.name }}</div>
            <div class="tech-desc">{{ t.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- PARTNER -->
    <section class="partner-section">
      <div class="partner-inner">
        <div class="partner-badge">🏛️ 中興新村育成創生夥伴</div>
        <h2 class="partner-title">政府育成認證，<br />讓創新與自然共同生長</h2>
        <p class="partner-desc">
          綠憩植研進駐中興新村創業育成中心，獲得政府資源支持，持續深耕低維護植栽技術研發與品牌推廣。
        </p>
        <div class="partner-logos">
          <div
            v-for="pl in partnerLogos"
            :key="pl.name"
            class="partner-logo-item"
          >
            <div class="partner-logo-circle">{{ pl.icon }}</div>
            <div class="partner-logo-name">{{ pl.name }}</div>
          </div>
        </div>
        <div
          style="
            display: flex;
            gap: 16px;
            justify-content: center;
            flex-wrap: wrap;
            margin-top: 40px;
          "
        >
          <router-link to="/contact" class="btn-primary"
            >了解企業合作</router-link
          >
          <router-link to="/services" class="btn-ghost"
            >ESG 綠化方案</router-link
          >
        </div>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <div class="footer-inner">
        <p>© 2026 綠憩植研 Green Rich Geam. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
const storyValues = [
  "🌱 低維護設計",
  "🧪 生物科技",
  "💚 療癒陪伴",
  "♻️ 永續環保",
];

const painPoints = [
  { icon: "💧", title: "澆水難拿捏<br>容易過多或過少" },
  { icon: "🥀", title: "植物容易枯萎<br>頻繁換植令人沮喪" },
  { icon: "🌱", title: "爛根問題嚴重<br>不知如何預防" },
  { icon: "🦟", title: "容易滋生蚊蟲<br>影響居家環境" },
  { icon: "🧪", title: "水培容易產生臭水<br>維護麻煩費時" },
  { icon: "⏰", title: "生活忙碌沒時間<br>照顧植物心有餘力不足" },
];

const techCards = [
  {
    icon: "💧",
    name: "均水導流技術",
    desc: "精準控制水分輸送，確保根系健康呼吸，維持植物最佳狀態，大幅減少澆水困擾。",
  },
  {
    icon: "🧬",
    name: "可替換營養模組",
    desc: "模組化設計讓營養補充變得簡單，持續供養，解決施肥複雜問題，針對不同植物提供專屬配方。",
  },
  {
    icon: "👁️",
    name: "水位視窗設計",
    desc: "直觀的水位顯示，只需每月一次簡單補水，即使再不擅長照護的人也能輕鬆上手。",
  },
  {
    icon: "💚",
    name: "綠色療癒陪伴",
    desc: "在繁瑣的日常生活中，擁有植物安靜平靜心靈的療癒。幸福生活，將大自然輕鬆帶入您家。",
  },
];

const partnerLogos = [
  { icon: "🏛️", name: "中興新村" },
  { icon: "🌿", name: "園藝治療師認證" },
  { icon: "♻️", name: "永續夥伴" },
  { icon: "🏆", name: "品質保證" },
];
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.about-page {
  font-family: "Noto Sans TC", "Microsoft JhengHei", sans-serif;
  background: #f7f5ef;
  color: #1c2b1a;
}

/* HERO */
.page-hero {
  background: linear-gradient(135deg, #2d5016 0%, #4e7b4f 100%);
  color: white;
  padding: 80px 40px;
  text-align: center;
}

.page-hero-inner {
  max-width: 600px;
  margin: 0 auto;
}

.section-label {
  font-size: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  opacity: 0.7;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-title {
  font-size: 3em;
  font-weight: 600;
  margin-bottom: 16px;
}

.page-sub {
  font-size: 1.1em;
  opacity: 0.85;
  line-height: 1.7;
}

/* STORY */
.story-section {
  max-width: 1200px;
  margin: 80px auto;
  padding: 0 40px;
}

.story-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.story-img {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  aspect-ratio: 1;
}

.story-img-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.story-img-content {
  opacity: 0.4;
}

.story-img-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 30px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
  color: white;
  text-align: right;
}

.story-img-overlay p {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 8px;
}

.story-img-overlay span {
  font-size: 13px;
  opacity: 0.8;
}

.section-title {
  font-size: 2em;
  font-weight: 600;
  color: #1c2b1a;
  margin-bottom: 24px;
  line-height: 1.3;
}

.section-sub {
  color: #6b7f68;
  line-height: 1.7;
}

.story-text {
  color: #6b7f68;
  line-height: 1.8;
  margin-bottom: 16px;
  font-size: 15px;
}

.story-values {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 24px;
}

.story-value-tag {
  padding: 8px 16px;
  background: #eaf2e0;
  color: #4e7b4f;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}

/* PAIN POINTS */
.pain-section {
  background: white;
  padding: 80px 40px;
  margin-top: 40px;
}

.pain-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.pain-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
}

.pain-item {
  background: #f7f5ef;
  border-radius: 12px;
  padding: 24px 20px;
  text-align: center;
  transition: all 0.3s;
}

.pain-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.pain-icon {
  font-size: 36px;
  margin-bottom: 12px;
}

.pain-title {
  font-size: 13px;
  color: #3d4f3a;
  line-height: 1.6;
  font-weight: 500;
}

/* TECH */
.tech-section {
  padding: 80px 40px;
  background: #f7f5ef;
}

.tech-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.tech-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 24px;
}

.tech-card {
  background: white;
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s;
}

.tech-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.tech-icon {
  font-size: 40px;
  margin-bottom: 16px;
}

.tech-name {
  font-size: 18px;
  font-weight: 600;
  color: #1c2b1a;
  margin-bottom: 12px;
}

.tech-desc {
  font-size: 14px;
  color: #6b7f68;
  line-height: 1.7;
}

/* PARTNER */
.partner-section {
  background: linear-gradient(135deg, #2d5016 0%, #4e7b4f 100%);
  color: white;
  padding: 80px 40px;
  text-align: center;
}

.partner-inner {
  max-width: 800px;
  margin: 0 auto;
}

.partner-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.15);
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 24px;
}

.partner-title {
  font-size: 2.2em;
  font-weight: 600;
  margin-bottom: 16px;
  line-height: 1.3;
}

.partner-desc {
  opacity: 0.85;
  line-height: 1.8;
  font-size: 16px;
  margin-bottom: 40px;
}

.partner-logos {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.partner-logo-item {
  text-align: center;
}

.partner-logo-circle {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin: 0 auto 8px;
}

.partner-logo-name {
  font-size: 13px;
  color: #9baa97;
  letter-spacing: 0.05em;
}

.btn-primary {
  padding: 14px 32px;
  background: white;
  color: #4e7b4f;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
  font-weight: 600;
}

.btn-primary:hover {
  background: #eaf2e0;
  transform: translateY(-2px);
}

.btn-ghost {
  padding: 14px 32px;
  background: transparent;
  border: 2px solid white;
  color: white;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
}

.btn-ghost:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* FOOTER */
.footer {
  background: #1c2b1a;
  color: #9baa97;
  text-align: center;
  padding: 40px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
}

/* Responsive */
@media (max-width: 768px) {
  .page-title {
    font-size: 2em;
  }

  .story-inner {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .pain-section,
  .tech-section,
  .partner-section {
    padding: 60px 20px;
  }

  .partner-title {
    font-size: 1.6em;
  }
}
</style>
